//reducers
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector } from 'hooks/redux.hooks';
import { getBeneficiaryDetails } from 'state/reducers/beneficiary.reducers';
//theme
import { HeaderPage1 } from 'theme/elements/Headers';

export default function CreateHeader() {
	const t = useAppSelector(selectTranslations);
	const details = useAppSelector(getBeneficiaryDetails);
	return (
		<HeaderPage1
			title={details.beneficiaryName || t('page.convert.create.header.title')}
			text={t('page.convert.create.header.text')}
		/>
	);
}
